import React from 'react';

import { useDispatch } from 'react-redux';

import { BOARD } from '../../../../redux/types';

import { IBoards } from '../../types/IBoards';

import { NavLink } from 'react-router-dom';

import './boardsTabs.scss';

const BoardsTabs: React.FC<IBoards> = ({ boards }) => {
  const dispatch = useDispatch();

  return (
    <div className='boards-tabs'>
      {boards.map((x) => (
        <NavLink className={({ isActive }) => (isActive ? 'board-btn board-btn-active' : 'board-btn')} key={x.id}
                 to={`./${x.id}`}>
          <span onClick={() => dispatch({ type: BOARD.SET_ACTIVE_BOARD, activeBoard: x.id })}>{x.name}</span>
        </NavLink>
      ))}
    </div>
  );
};

export default BoardsTabs;